__turbopack_context__.v({
  "ProductImageCard": "vGrkvq_ProductImageCard",
  "ProductImageCard__Content": "vGrkvq_ProductImageCard__Content",
  "ProductImageCard__Description": "vGrkvq_ProductImageCard__Description",
  "ProductImageCard__Images": "vGrkvq_ProductImageCard__Images",
  "ProductImageCard__ProductImage": "vGrkvq_ProductImageCard__ProductImage",
  "ProductImageCard__ProductImage--Loaded": "vGrkvq_ProductImageCard__ProductImage--Loaded",
  "ProductImageCard__ProductImageWrapper": "vGrkvq_ProductImageCard__ProductImageWrapper",
  "ProductImageCard__ProductLogoImage": "vGrkvq_ProductImageCard__ProductLogoImage",
  "ProductImageCard__ProductLogoImage--Loaded": "vGrkvq_ProductImageCard__ProductLogoImage--Loaded",
  "ProductImageCard__ProductLogoImageWrapper": "vGrkvq_ProductImageCard__ProductLogoImageWrapper",
  "imageInvertation": "vGrkvq_imageInvertation",
});
